import axios from 'axios';

import { API } from '@/api/constants';

const zipCodeInstance = axios.create({
  baseURL: API,
});

const apiName = 'zipcode';
const apiVersion = 'v1';
const baseUrl = `${apiName}/${apiVersion}/`;

const searchZipCode = async (zipCode) =>
  (await zipCodeInstance.get(`${baseUrl}zip-codes?zip-code=${zipCode}`)).data;

const listStates = async () =>
  (await zipCodeInstance.get(`${baseUrl}states`)).data;

const listCitiesByState = async (stateCode) =>
  (await zipCodeInstance.get(`${baseUrl}cities/state/${stateCode}`)).data;

const getCity = async (cityId) =>
  (await zipCodeInstance.get(`${baseUrl}cities/${cityId}`)).data;

export default {
  searchZipCode,
  listStates,
  listCitiesByState,
  getCity,
};
